<template>
  <div class="org-certificate common-certificate">
    <action-bar>
      <btn-style :btn-list="btnList"></btn-style>
    </action-bar>

    <normal-table
      ref="commonTable"
      :table-col="tableCol"
      :table-data="orgList"
      :first-table-col="firstTableCol"
      :operator="operator"
      :operate-col="operateCol"
      :show-edit="true"
      :paging="orgPaging"
      @pagination="handleSizeOrPageChange"
    >
      <template slot="status" slot-scope="{ param }">
        <span class="cert-status" :class="param.row.Status === 'normal'?'is-normal':'is-cancel'">{{
          formatStatus(param.row.Status) || $constants.EMPTY
        }}</span>
      </template>
    </normal-table>
    <init-org ref="initOrg" @update:list="getList()"></init-org>
    <import-org ref="importOrg" @update:list="getList()"></import-org>
    <see-dialog ref="seeDialog"></see-dialog>
    <gen-org ref="genOrg" @update:list="getList()"></gen-org>
  </div>
</template>

<script>
import auth from '@/auth/index'
import { mapState, mapActions } from 'vuex'
import initOrg from './components/initOrg'
import importOrg from './components/importOrg'
import seeDialog from './components/seeDialog' //查看公钥的弹窗
import genOrg from './components/genOrg' //生成组织证书弹窗
export default {
  name: 'Organization',
  components: {
    initOrg,
    importOrg,
    seeDialog,
    genOrg
  },
  data() {
    return {
      btnList: [
        {
          btnContent: '生成组织证书',
          click: () => {
            return this.genOrg()
          },
          icon: 'icon-gen',
          auth: auth.certificate.certAuth.orgCert.createOrgCert
        },
        {
          btnContent: '导入组织证书',
          click: () => {
            return this.importOrg()
          },
          icon: 'icon-import',
          auth: auth.certificate.certAuth.orgCert.importOrgCert
        },
        {
          btnContent: '申请组织证书',
          click: () => {
            return this.initOrg()
          },
          icon: 'icon-apply',
          auth: auth.certificate.certAuth.orgCert.requireOrgCert
        }
      ],
      // 设置table的列
      tableCol: [
        {
          prop: 'OrgId',
          label: '组织ID',
          minWidth: 139
        },
        {
          prop: 'OrgName',
          label: '组织名称',
          minWidth: 116
        },
        {
          prop: 'AuthType',
          label: '认证模式',
          formatter: row => {
            return this.algoToAuthType(row.Algorithm)
          },
          minWidth: 206
        },
        {
          prop: 'Algorithm',
          label: '密码算法',
          formatter: row => {
            return this.formatAlgo(row.Algorithm)
          },
          minWidth: 122
        },
        {
          prop: 'CertUse',
          label: '证书用途',
          formatter: row => {
            return this.formatUsage(row.CertUse)
          },
          minWidth: 86
        },
        {
          prop: 'Status',
          label: '状态',
          minWidth: 126,
          slotName: 'status',
          align: 'center',
          headerAlign: 'center',
        },
        {
          prop: 'createAt',
          label: '创建时间',
          formatter: row => {
            return this.formatTime(row)
          },
          minWidth: 164
        }
      ],
      // table的基本操作
      operator: [
        {
          text: '查看公钥',
          click: (row, col, cellValue) => {
            return this.getInfo(row)
          },
          showText: true,
          icon: 'icon-check'
        },
        {
          text: '下载',
          label: '下载',
          showText: true,
          click: (row, col, cellValue) => {
            return this.downloadFile(row)
          },
          icon: 'icon-download'
        },
        {
          showText: true,
          text: '撤销',
          click: (row, col, cellValue) => {
            return this.delInfo(row)
          },
          icon: 'icon-cancel',
          formatter: row => {
            return this.judgeShow(row)
          }
        }
      ],
      operateCol: {
        minWidth: 208
      },
      firstTableCol: {
        select: false,
        type: 'selection'
      }
    }
  },
  computed: {
    ...mapState({
      orgList: state => state.certificate.org_list,
      orgPaging: state => state.certificate.org_paging
    })
  },
  mounted() {
    this.getList()
  },
  methods: {
    ...mapActions(['getOrgLists']),
    getList(limit = 10, offset = 0, name) {
      let params = {
        offset,
        limit,
        certType: 0,
        name,
        chainMode: 'permissionedWithCert' //普通认证
      }
      this.getOrgLists(params)
    },
    handleSizeOrPageChange(data) {
      const { offset, limit } = data
      this.getList(limit, offset * limit)
    },
    formatTime(row) {
      return this.$utils.dateFormat('YYYY-mm-dd HH:MM', row.createAt)
    },
    algoToAuthType(algo) {
      switch (algo) {
        case 2:
          return 'permissionedWithIBC'
        default:
          return 'permissionedWithCert'
      }
    },
    formatAlgo(algo) {
      switch (algo) {
        case 0:
          return '国密'
        case 1:
          return 'ECDSA'
        default:
          return 'SM9'
      }
    },
    formatUsage(usage) {
      switch (usage) {
        case 0:
          return '签名'
        case 1:
          return '通信'
        case 2:
          return 'PEM'
        case 3:
          return 'IBC签名'
        case 4:
          return 'IBC通信'
        default:
          return '未知用途:' + usage
      }
    },
    formatStatus(status) {
      return status === 'normal' ? '正常' : '已撤销'
    },
    initOrg() {
      this.$refs.initOrg.handleOpen()
    },
    importOrg() {
      this.$refs.importOrg.handleOpen()
    },
    genOrg() {
      this.$refs.genOrg.handleOpen()
    },
    getInfo(row) {
      let data = {
        cert: row.Cert,
        //title: row.OrgName
        title: '查看组织公钥',
        type: 'Cert'
      }
      this.$refs.seeDialog.handleOpen(data)
    },
    downloadFile(row) {
      const name = row.OrgName + '.key'
      this.$utils.createFileAndDownload(name, row.Cert)
    },
    // 判断撤销按钮显示与隐藏
    judgeShow(row) {
      return row.Source === 'ca_service' && row.Status === 'normal'
    },
    delInfo(row) {
      this.$prompt('请输入组织证书撤销理由', '撤销证书', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /^.+$/,
        inputErrorMessage: '请输入撤销原因'
      })
        .then(({ value }) => {
          let param = {
            certId: row.id,
            reason: value
          }
          this.$apis.certificate.revokeCert(param).then(res => {
            this.$message({
              type: 'success',
              message: `组织证书撤销成功！`
            })
          })
          this.refresh()
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '取消撤销'
          })
        })
    },
    refresh() {
      const { offset, limit } = this.orgPaging
      this.getList(limit, offset)
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/styles/variables/theme';
@import '@/styles/variables/adaptation';
.org-certificate.common-certificate {
  .normal-table-wrap {
    height: 100%;
    min-height: var(--common-certificate-list-min-height);

    /deep/ {
      .el-empty {
        height: 100%;
        min-height: var(--common-certificate-list-min-height);
      }

      .normal-table {
        height: 100%;
        min-height: var(--common-certificate-list-min-height);

        .cert-status {
          padding: var(--common-certificate-list-status-padding);
          display: inline-block;
          &.is-normal {
            color: var(--base-color-success);
          }
          
          &.is-cancel {
            color: var(--base-color-danger);
            background-color: rgba(233, 87, 87, 0.34);
          }
        }
      }
    }
  }
}
</style>
